module.exports = __webpack_public_path__ + "static/img/icon_baoming.b5e02386.png";